// assets/bundle-configurator.js
(function () {
  document.querySelectorAll('#bundle-configurator .bundle-configurator__root').forEach(function (root) {
    var groupsWrap    = root.querySelector('.bundle-configurator__groups');
    var addBtn        = root.querySelector('[data-bundle-add]');
    var totalEl       = root.querySelector('[data-bundle-total]');
    var savedEl       = root.querySelector('[data-bundle-saved]');
    var listEl        = root.querySelector('[data-summary-list]');
    var errEl         = root.querySelector('[data-bundle-error]');
    var totalRegEl    = root.querySelector('[data-bundle-total-regular]');
    var totalPayEl    = root.querySelector('[data-bundle-total-pay]');
    var mainCompareAt = toInt(root.dataset.mainCompareAt) || 0;
    var sectionId     = groupsWrap && groupsWrap.dataset.sectionId;
    var cfgEl         = sectionId ? document.getElementById('bundle-config-schema-' + sectionId) : null;
    if (!cfgEl) return;

    function formatEuro(cents) {
      var n = (cents || 0) / 100;
      return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EUR';
    }
    function toInt(v) {
      var n = parseInt(String(v || '').replace(/[^\d]/g, ''), 10);
      return Number.isFinite(n) ? n : NaN;
    }
    function showError(el, msg) {
      if (!el) return;
      el.hidden = false;
      el.textContent = msg || 'Fehler beim Hinzufügen zum Warenkorb.';
      try { el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    }
    function readJsonSafe(res) {
      return res.json().catch(function () { return {}; });
    }

    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      console.error(e);
      return;
    }
    cfg.groups = (cfg.groups || []).map(function (g) {
      g.required = !!g.required;
      return g;
    });

    var itemIndex = {};
    (cfg.items || []).forEach(function (it) {
      if (!itemIndex[it.group_id]) itemIndex[it.group_id] = [];
      itemIndex[it.group_id].push(it);
    });

    var state = { selections: {} }; // selections[groupId] = Array von Auswahl-Objekten

    var groupMode = {};
    (cfg.groups || []).forEach(function (g) {
      groupMode[g.id] = g.pricing_mode || 'normal';
    });

    // Modal-Elemente pro Root (Varianten-Modal)
    var modal         = root.querySelector('[data-variant-modal]');
    var modalTitle    = modal ? modal.querySelector('[data-variant-modal-title]') : null;
    var modalBody     = modal ? modal.querySelector('[data-variant-modal-body]') : null;
    var modalConfirm  = modal ? modal.querySelector('[data-variant-modal-confirm]') : null;
    var modalCloseEls = modal ? modal.querySelectorAll('[data-variant-modal-close]') : [];

    // Produkt-Info-Modal Elemente
    var productModal        = root.querySelector('[data-product-modal]');
    var productModalTitle   = productModal ? productModal.querySelector('[data-product-modal-title]') : null;
    var productModalBody    = productModal ? productModal.querySelector('[data-product-modal-body]') : null;
    var productModalImage   = productModal ? productModal.querySelector('[data-product-modal-image]') : null;
    var productModalPrice   = productModal ? productModal.querySelector('[data-product-modal-price]') : null;
    var productModalLink    = productModal ? productModal.querySelector('[data-product-modal-link]') : null;
    var productModalCloseEls = productModal ? productModal.querySelectorAll('[data-product-modal-close]') : [];

    function closeVariantModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.removeAttribute('data-open');
    }

    function closeProductModal() {
      if (!productModal) return;
      productModal.hidden = true;
      productModal.removeAttribute('data-open');
    }

    if (modalCloseEls && modalCloseEls.length) {
      Array.prototype.forEach.call(modalCloseEls, function (el) {
        el.addEventListener('click', function () {
          closeVariantModal();
        });
      });
    }

    if (productModalCloseEls && productModalCloseEls.length) {
      Array.prototype.forEach.call(productModalCloseEls, function (el) {
        el.addEventListener('click', function () {
          closeProductModal();
        });
      });
    }

    function openVariantModal(product, variants, currentVariantId, onConfirm) {
      if (!modal || !modalBody || !modalTitle || !modalConfirm) return;

      modalTitle.textContent = product.title || '';
      modalBody.innerHTML = '';

      variants.forEach(function (v) {
        var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
        var priceHtml = hasCompare
          ? formatEuro(v.price) + ' <s class="money--compare">' + formatEuro(v.compare_at_price) + '</s>'
          : formatEuro(v.price);

        var label = document.createElement('label');
        label.className = 'bundle-variant-option';
        label.innerHTML =
          '<input type="radio" name="bundle-variant-choice" value="' + v.id + '" ' +
          (String(v.id) === String(currentVariantId) ? 'checked' : '') + '>' +
          '<span class="bundle-variant-option__title">' + (v.title || '') + '</span>' +
          '<span class="bundle-variant-option__price">' + priceHtml + '</span>';
        modalBody.appendChild(label);
      });

      modal.hidden = false;
      modal.setAttribute('data-open', 'true');

      modalConfirm.onclick = function () {
        var checked = modalBody.querySelector('input[name="bundle-variant-choice"]:checked');
        if (!checked) return;
        var chosen = variants.find(function (v) {
          return String(v.id) === String(checked.value);
        });
        if (chosen && typeof onConfirm === 'function') {
          onConfirm(chosen);
        }
        closeVariantModal();
      };
    }

    function openProductModal(product, variant) {
      if (!productModal || !productModalTitle || !productModalBody) return;

      productModalTitle.textContent = product.title || '';
      
      // Produktbeschreibung anzeigen
      productModalBody.innerHTML = product.description || '<p>Keine Beschreibung verfügbar.</p>';

      // Produktbild
      if (productModalImage) {
        productModalImage.src = product.featured_image || '';
        productModalImage.alt = product.title || '';
      }

      // Preis mit Streichpreis
      if (productModalPrice) {
        var price = variant ? variant.price : product.price;
        var compareAt = variant ? variant.compare_at_price : product.compare_at_price;
        var hasCompare = compareAt && compareAt > price;

        if (hasCompare) {
          productModalPrice.innerHTML = 
            '<strong>' + formatEuro(price) + '</strong> ' +
            '<s class="money--compare">' + formatEuro(compareAt) + '</s>';
        } else {
          productModalPrice.innerHTML = '<strong>' + formatEuro(price) + '</strong>';
        }
      }

      // Link zur Produktseite
      if (productModalLink && product.url) {
        productModalLink.href = product.url;
        productModalLink.style.display = 'inline-block';
      } else if (productModalLink) {
        productModalLink.style.display = 'none';
      }

      productModal.hidden = false;
      productModal.setAttribute('data-open', 'true');
    }

    function applySelectionForTile(opts) {
      var grid         = opts.grid;
      var groupId      = opts.groupId;
      var tile         = opts.tile;
      var noneBtn      = opts.noneBtn;
      var selectionObj = opts.selectionObj;
      var multiSelect  = opts.multiSelect;

      if (!Array.isArray(state.selections[groupId])) {
        state.selections[groupId] = [];
      }

      if (multiSelect) {
        var isCurrentlySelected = tile.classList.contains('is-selected');

        if (isCurrentlySelected) {
          tile.classList.remove('is-selected');
          state.selections[groupId] = state.selections[groupId].filter(function (sel) {
            return sel.product_id !== selectionObj.product_id || sel.variantId !== selectionObj.variantId;
          });
          if (!state.selections[groupId].length && noneBtn) {
            noneBtn.classList.add('is-selected');
          }
        } else {
          tile.classList.add('is-selected');
          if (noneBtn) noneBtn.classList.remove('is-selected');

          var exists = state.selections[groupId].some(function (sel) {
            return sel.product_id === selectionObj.product_id && sel.variantId === selectionObj.variantId;
          });
          if (!exists) {
            state.selections[groupId].push(selectionObj);
          }
        }
      } else {
        grid.querySelectorAll('.bundle-item').forEach(function (x) {
          x.classList.remove('is-selected');
        });
        tile.classList.add('is-selected');
        if (noneBtn) noneBtn.classList.remove('is-selected');
        state.selections[groupId] = [selectionObj];
      }

      updateSummary();
      validate();
    }

    // Gruppen rendern
    (cfg.groups || []).forEach(function (g) {
      var groupEl = groupsWrap.querySelector('.bundle-group[data-group-id="' + CSS.escape(g.id) + '"]');
      if (!groupEl) return;
      var grid = groupEl.querySelector('.bundle-items');

      // Optional: "Kein Produkt"
      if (!g.required) {
        var none = document.createElement('button');
        none.type = 'button';
        none.className = 'bundle-item bundle-item--none is-selected';
        none.dataset.none = 'true';
        var noneLabel = (g.none_label && String(g.none_label).trim()) || 'Kein Produkt ausgewählt';
        none.innerHTML = '<div>' + noneLabel + '</div>';
        grid.appendChild(none);
        state.selections[g.id] = [];

        none.addEventListener('click', function () {
          grid.querySelectorAll('.bundle-item').forEach(function (x) { x.classList.remove('is-selected'); });
          none.classList.add('is-selected');
          state.selections[g.id] = [];
          updateSummary();
          validate();
        });
      }

      // Produkt-Kacheln
      (itemIndex[g.id] || []).forEach(function (it) {
        var p = it.product;
        var variants = (p.variants || []).filter(function (v) { return v.available; });
        if (!variants.length) return;

        var defaultVariant = variants[0];
        var isFree = (groupMode[g.id] || 'normal') === 'free';
        var isPaid = !isFree;

        var tile = document.createElement('div');
        tile.className = 'bundle-item';
        tile.setAttribute('role', 'button');
        tile.dataset.productId = p.id;
        tile.dataset.title = p.title;
        tile.dataset.image = p.featured_image || '';
        tile.dataset.variantId = String(defaultVariant.id);
        tile.dataset.variantPrice = String(defaultVariant.price);
        tile.dataset.variantCompareAt = String(defaultVariant.compare_at_price || 0);

        // Preis-HTML mit Streichpreis-Logik (Streichpreis rechts)
        var priceHtml = '';
        var hasCompare = defaultVariant.compare_at_price && defaultVariant.compare_at_price > defaultVariant.price;

        if (isFree) {
          // Kostenlose Gruppe: Streichpreis = aktueller Preis, Endpreis = 0
          priceHtml = 'Kostenlos <s class="money--compare">' + formatEuro(defaultVariant.price) + '</s>';
        } else if (hasCompare) {
          // Kostenpflichtig mit Streichpreis
          priceHtml = formatEuro(defaultVariant.price) + ' <s class="money--compare">' + formatEuro(defaultVariant.compare_at_price) + '</s>';
        } else {
          // Kostenpflichtig ohne Streichpreis
          priceHtml = formatEuro(defaultVariant.price);
        }

        var priceCls = isFree ? 'bundle-item__price is-free' : 'bundle-item__price';

        // "Mehr Informationen" Button nur bei kostenpflichtigen Produkten
        var infoButtonHtml = isPaid 
          ? '<button type="button" class="bundle-item__info-btn" data-info-btn title="Mehr Informationen">ℹ</button>'
          : '';

        tile.innerHTML =
          '<img class="bundle-item__img" src="' + (p.featured_image || '') + '" alt="">' +
          '<div class="bundle-item__title">' + p.title + '</div>' +
          '<div class="bundle-item__price-row">' +
            '<div class="' + priceCls + '" data-price>' + priceHtml + '</div>' +
            infoButtonHtml +
          '</div>';
        grid.appendChild(tile);

        // Event für Info-Button
        var infoBtn = tile.querySelector('[data-info-btn]');
        if (infoBtn) {
          infoBtn.addEventListener('click', function (e) {
            e.stopPropagation(); // Verhindert Tile-Klick
            var currentVariantId = tile.dataset.variantId;
            var currentVariant = variants.find(function (v) {
              return String(v.id) === String(currentVariantId);
            }) || defaultVariant;
            openProductModal(p, currentVariant);
          });
        }

        if (!Array.isArray(state.selections[g.id])) {
          state.selections[g.id] = [];
        }

        tile.addEventListener('click', function (e) {
          // Ignoriere Klicks auf den Info-Button
          if (e.target.closest('[data-info-btn]')) return;

          var multiSelect = (groupMode[g.id] || 'normal') === 'normal';
          var noneBtn = grid.querySelector('.bundle-item--none');
          var hasMultipleVariants = variants.length > 1;

          // Wenn bereits ausgewählt und kostenpflichtige (Multi-Select-)Gruppe:
          // -> Auswahl komplett entfernen, kein Modal öffnen
          if (multiSelect && tile.classList.contains('is-selected')) {
            var currentVariantId = tile.dataset.variantId || (defaultVariant && defaultVariant.id);
            var selArr = Array.isArray(state.selections[g.id]) ? state.selections[g.id] : [];
            var vIdStr = String(currentVariantId);

            selArr = selArr.filter(function (sel) {
              return String(sel.product_id) !== String(p.id) || String(sel.variantId) !== vIdStr;
            });
            state.selections[g.id] = selArr;

            tile.classList.remove('is-selected');
            if (!selArr.length && noneBtn) {
              noneBtn.classList.add('is-selected');
            }

            updateSummary();
            validate();
            return;
          }

          // Mehrere Varianten → Modal öffnen
          if (hasMultipleVariants) {
            var currentVariantIdForModal = tile.dataset.variantId || defaultVariant.id;

            openVariantModal(p, variants, currentVariantIdForModal, function (chosen) {
              tile.dataset.variantId = String(chosen.id);
              tile.dataset.variantPrice = String(chosen.price);
              tile.dataset.variantCompareAt = String(chosen.compare_at_price || 0);

              // Preis-Element aktualisieren
              var priceEl = tile.querySelector('[data-price]');
              if (priceEl) {
                var chosenHasCompare = chosen.compare_at_price && chosen.compare_at_price > chosen.price;
                if (isFree) {
                  priceEl.innerHTML = 'Kostenlos <s class="money--compare">' + formatEuro(chosen.price) + '</s>';
                } else if (chosenHasCompare) {
                  priceEl.innerHTML = formatEuro(chosen.price) + ' <s class="money--compare">' + formatEuro(chosen.compare_at_price) + '</s>';
                } else {
                  priceEl.textContent = formatEuro(chosen.price);
                }
              }

              var selectionObj = {
                product_id: p.id,
                title: p.title + ' – ' + (chosen.title || ''),
                image: tile.dataset.image,
                variantId: chosen.id,
                price: chosen.price,
                compare_at_price: chosen.compare_at_price || 0
              };

              applySelectionForTile({
                grid: grid,
                groupId: g.id,
                tile: tile,
                noneBtn: noneBtn,
                selectionObj: selectionObj,
                multiSelect: multiSelect
              });
            });

            return;
          }

          // Nur eine Variante → Direktwahl
          var v = defaultVariant;
          tile.dataset.variantId = String(v.id);
          tile.dataset.variantPrice = String(v.price);
          tile.dataset.variantCompareAt = String(v.compare_at_price || 0);

          var selectionObjSingle = {
            product_id: p.id,
            title: p.title,
            image: tile.dataset.image,
            variantId: v.id,
            price: v.price,
            compare_at_price: v.compare_at_price || 0
          };

          applySelectionForTile({
            grid: grid,
            groupId: g.id,
            tile: tile,
            noneBtn: grid.querySelector('.bundle-item--none'),
            selectionObj: selectionObjSingle,
            multiSelect: multiSelect
          });
        });
      });

      // Default für Pflichtgruppen
      if (g.required) {
        var hasSelection = Array.isArray(state.selections[g.id]) && state.selections[g.id].length > 0;
        if (!hasSelection) {
          var firstTile = grid.querySelector('.bundle-item:not(.bundle-item--none)');
          if (firstTile) firstTile.click();
        }
      }
    });

    function validate() {
      var ok = (cfg.groups || []).every(function (g) {
        if (!g.required) return true;
        var sel = state.selections[g.id];
        return Array.isArray(sel) && sel.length > 0;
      });

      addBtn.disabled = !ok;
      if (ok) {
        errEl.hidden = true;
        errEl.textContent = '';
      } else {
        showError(errEl, 'Bitte alle Pflichtgruppen auswählen.');
      }
    }

    function computeTotals() {
      var mainPrice   = toInt(root.dataset.mainPrice) || 0;
      var mainRegular = (mainCompareAt && mainCompareAt > mainPrice) ? mainCompareAt : mainPrice;

      var regularTotal    = mainRegular;
      var discountedTotal = mainPrice;

      (cfg.groups || []).forEach(function (g) {
        var sels = Array.isArray(state.selections[g.id]) ? state.selections[g.id] : [];
        if (!sels.length) return;

        var isFreeGroup = (groupMode[g.id] || 'normal') === 'free';

        sels.forEach(function (sel) {
          var price = sel.price || 0;
          var compareAt = sel.compare_at_price || 0;
          // Für regularTotal: wenn compare_at_price vorhanden, diesen nehmen
          var regularPrice = (compareAt && compareAt > price) ? compareAt : price;
          
          regularTotal += regularPrice;
          if (!isFreeGroup) {
            discountedTotal += price;
          }
        });
      });

      var totalSavings = regularTotal - discountedTotal;
      var paidSum      = discountedTotal;
      var savings      = totalSavings;
      var pct          = regularTotal > 0 ? Math.round((savings / regularTotal) * 100) : 0;

      return {
        regularTotal: regularTotal,
        discountedTotal: discountedTotal,
        totalSavings: totalSavings,
        paidSum: paidSum,
        savings: savings,
        pct: pct
      };
    }

    function renderSummaryList() {
      if (!listEl) return;
      listEl.innerHTML = '';

      // Hauptprodukt
      var mainTitle = root.dataset.mainTitle || '';
      var mainImg   = root.dataset.mainImage || '';
      var mainPrice = toInt(root.dataset.mainPrice) || 0;
      if (mainTitle && mainPrice >= 0) {
        var liMain = document.createElement('li');
        liMain.className = 'bundle-summary__item';
        var hasMainDiscount = (mainCompareAt && mainCompareAt > mainPrice);
        liMain.innerHTML =
          '<img src="' + mainImg + '" alt="">' +
          '<div class="bundle-summary__item-title">' + mainTitle + '</div>' +
          '<div class="bundle-summary__item-price bundle-summary__value--stack">' +
          (hasMainDiscount ? '<s class="money--compare">' + formatEuro(mainCompareAt) + '</s>' : '') +
          '<strong>' + formatEuro(mainPrice) + '</strong>' +
          '</div>';
        listEl.appendChild(liMain);
      }

      // Gewählte Gruppenartikel
      (cfg.groups || []).forEach(function (g) {
        var sels = Array.isArray(state.selections[g.id]) ? state.selections[g.id] : [];
        if (!sels.length) return;

        var isFree = (groupMode[g.id] || 'normal') === 'free';

        sels.forEach(function (sel) {
          var li = document.createElement('li');
          li.className = 'bundle-summary__item';

          var selPrice = sel.price || 0;
          var selCompareAt = sel.compare_at_price || 0;
          var hasSelCompare = selCompareAt && selCompareAt > selPrice;

          if (isFree) {
            // Kostenlose Gruppe: Streichpreis = aktueller Preis, Endpreis = 0
            li.innerHTML =
              '<img src="' + (sel.image || '') + '" alt="">' +
              '<div class="bundle-summary__item-title">' + sel.title + '</div>' +
              '<div class="bundle-summary__item-price bundle-summary__value--stack">' +
              '<s class="money--compare">' + formatEuro(selPrice) + '</s>' +
              '<strong>' + formatEuro(0) + '</strong>' +
              '</div>';
          } else if (hasSelCompare) {
            // Kostenpflichtig mit Streichpreis
            li.innerHTML =
              '<img src="' + (sel.image || '') + '" alt="">' +
              '<div class="bundle-summary__item-title">' + sel.title + '</div>' +
              '<div class="bundle-summary__item-price bundle-summary__value--stack">' +
              '<s class="money--compare">' + formatEuro(selCompareAt) + '</s>' +
              '<strong>' + formatEuro(selPrice) + '</strong>' +
              '</div>';
          } else {
            // Kostenpflichtig ohne Streichpreis
            li.innerHTML =
              '<img src="' + (sel.image || '') + '" alt="">' +
              '<div class="bundle-summary__item-title">' + sel.title + '</div>' +
              '<div class="bundle-summary__item-price"><strong>' + formatEuro(selPrice) + '</strong></div>';
          }

          listEl.appendChild(li);
        });
      });
    }

    function updateSummary() {
      var totals = computeTotals();
      if (totalRegEl) totalRegEl.textContent = formatEuro(totals.regularTotal);
      if (totalPayEl) totalPayEl.textContent = formatEuro(totals.discountedTotal);
      if (savedEl)    savedEl.textContent    = formatEuro(totals.totalSavings);
      renderSummaryList();
    }

    addBtn.addEventListener('click', function () {
      validate();
      if (addBtn.disabled) return;

      var mainVariantId = toInt(root.dataset.mainVariantId);
      var bundleId      = 'BNDL-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
      var items         = [];

      if (Number.isInteger(mainVariantId) && mainVariantId > 0) {
        items.push({
          id: mainVariantId,
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_group: 'main',
            _bundle_pricing_mode: 'normal',
            _bundle_role: 'main'
          }
        });
      }

      (cfg.groups || []).forEach(function (g) {
        var sels = Array.isArray(state.selections[g.id]) ? state.selections[g.id] : [];
        if (!sels.length) return;

        var mode = groupMode[g.id] || 'normal';

        sels.forEach(function (sel) {
          var vid = toInt(sel.variantId);
          if (!Number.isInteger(vid) || vid <= 0) return;
          items.push({
            id: vid,
            quantity: 1,
            properties: {
              _bundle_id: bundleId,
              _bundle_group: g.id,
              _bundle_pricing_mode: mode
            }
          });
        });
      });

      if (!items.length) {
        showError(errEl, 'Keine gültigen Positionen ausgewählt.');
        return;
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { bundle_id: bundleId } })
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          if (!res.ok) {
            return readJsonSafe(res).then(function (data) {
              var raw = data && (data.message || data.description) ? String(data.message || data.description) : '';
              if (res.status === 422) {
                var friendly =
                  /maximale menge/i.test(raw) ? 'Maximale Bestellmenge bereits erreicht. Bitte Warenkorb prüfen.' :
                  /out of stock|not enough|nicht.*bestand/i.test(raw) ? 'Nicht genügend Bestand für einen der Artikel.' :
                  raw || 'Eintrag konnte nicht hinzugefügt werden.';
                showError(errEl, friendly);
                return;
              }
              showError(errEl, raw || ('Unerwarteter Fehler (' + res.status + ').'));
            });
          }
          window.location.href = '/cart';
        })
        .catch(function (e) {
          console.error(e);
          showError(errEl, 'Netzwerkfehler. Bitte erneut versuchen.');
        });
    });

    // Init
    var noRequired = !(cfg.groups || []).some(function (g) { return g.required; });
    if (noRequired) {
      var initTotals = computeTotals();
      if (totalEl) totalEl.textContent = formatEuro(initTotals.paidSum);
      if (savedEl) savedEl.textContent = formatEuro(initTotals.savings);
      renderSummaryList();
    }
    validate();
  });
})();